module.exports = __webpack_public_path__ + "static/media/agenda-del-pages-2018-400px.069f680c.png";